(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vp-video"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduire = window.matchMedia('(prefers-reduced-motion: reduce)');
    const demarrer = (racine) => {
      if (racine.dataset.vpPret) return;
      racine.dataset.vpPret = 'oui';
      const v = racine.querySelector('video');
      const b = racine.querySelector('[data-vp-video-bouton]');
      if (!v || !b) return;
      v.removeAttribute('controls');
      let voulu = !reduire.matches;          // le visiteur veut-il le mouvement ?
      let visible = false;
      const maj = () => {
        const lecture = !v.paused;
        b.setAttribute('aria-pressed', lecture ? 'false' : 'true');
        b.querySelector('[data-vp-video-libelle]').textContent = lecture ? b.dataset.libellePause : b.dataset.libelleLecture;
        racine.classList.toggle('vp-video--lecture', lecture);
      };
      const appliquer = () => {
        if (voulu && visible) { v.preload = 'auto'; v.play().catch(() => {}); } else { v.pause(); }
      };
      b.addEventListener('click', () => { voulu = v.paused; if (voulu) visible = true; appliquer(); });
      v.addEventListener('play', maj); v.addEventListener('pause', maj);
      new IntersectionObserver((e) => { visible = e[0].isIntersecting; appliquer(); }, { threshold: 0.25 }).observe(v);
      reduire.addEventListener('change', () => { if (reduire.matches) { voulu = false; appliquer(); } });
      maj();
    };
    const tout = () => document.querySelectorAll('[data-vp-video]').forEach(demarrer);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
    document.addEventListener('shopify:section:load', tout);
  })();
  } catch(e) { console.error(e); }
})();

})();
